export const ApiRoute = {
  BANK_LOTS: (bankId: string) => `banks/${bankId}/lots`,
  BANKS: (bankId: string) => `banks/${bankId}/stat`,
  CEMETERY: 'cemetery',
  CEMETERY_FILTERS: `lots/filter_value`,
  CEMETERY_MAUSOLEUMS: `mausoleums`,
  CEMETERY_SECTIONS: `cemetery/sections`,
  LOT: (lotId: string) => `lots/${lotId}`,
  LOTS: `lots`,
  LOT_REQUEST: `lot_request`,
  MAUSOLEUM_BANKS: (mausoleumId: string) => `mausoleums/${mausoleumId}/banks`,
};
